import React, { useEffect, useState, useRef } from 'react'

import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import '../../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';

import axios from "@fuse/utils/axios";
import { convertToTimezone } from 'helper/common';

function IncidentsTab(props) {
    const tableHeaders = [
        { field: 'serial_no', headerName: 'Serial Number', headerComponent: (prop) => (CustomFilter(prop, '', gridRef)), minWidth: 200, width: 300, },
        { field: 'alert_id', headerName: 'Alert ID', headerComponent: (prop) => (CustomFilter(prop, '', gridRef)), minWidth: 200, width: 300 },
        {
            field: "severity",
            headerName: "Severity",
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef)),
            minWidth: 200
        },
        {
            field: "Event Date & Time",
            headerName: "Event Date & Time",
            minWidth: 200,
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef))
        },
        {
            field: "problem",
            headerName: "Description",
            minWidth: 350,
            maxWidth: 350,
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef))
        },
        {
            field: "Recovery Time",
            headerName: "Recovery Time",
            minWidth: 200,
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef))
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef))
        },
        {
            field: "duration",
            headerName: "Duration",
            headerComponent: (prop) => (CustomFilter(prop, '', gridRef)),
            minWidth: 200,
            maxWidth: 140
        }
    ];

    const gridRef = useRef()

    const onGridReady = params => {
        // Following line to make the currently visible columns fit the screen  
        params.api.sizeColumnsToFit();

        // Following line dymanic set height to row on content
        params.api.resetRowHeights();
    };
    const [rowData, setRowData] = useState([]);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);

    const [loading, setLoading] = useState(false)

    const { assetDetails } = props

    function formtIncidents(incidents) {
        return incidents.map((item) => {
            return {
                id: item.id,
                // ticket_number: '27927',
                serial_no: item.serial_no || '-',
                severity: item.event_severity,
                'Event Date & Time': item.problem_time,
                'Recovery Time': item.recovery_time,
                status: item.event_status,
                problem: item.alert_subject,
                duration: item.event_duration,
                alert_id: item?.alert_id
            }
        })
    }
    function getIncidents() {
        if (!assetDetails) return
        setLoading(true)
        axios.get(`/assets/fetch-asset-incident/${assetDetails.id}`, {
        }).then((res) => {
            const { incident } = res.data.data;
            setRowData(formtIncidents(incident))
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        getIncidents()
    }, [])

    if (loading) {
        return (
            <FuseLoading />
        )
    }

    return (
        <>
            {rowData.length === 0 &&
                <div className='no_data_holder'>
                    <img src='assets/images/nodata.svg' alt='icon' />
                    <p className='bold_txt'>It's all empty here!</p>
                    <p className='normal_txt'>No data to show yet</p>
                </div>
            }

            {
                rowData.length > 0 &&
                <div
                    className="ag-theme-alpine"
                    style={{
                        width: "100%",
                        height: windowHeight + 105,
                        fontSize: '12px'
                    }}
                >
                    <AgGridReact
                        ref={gridRef}
                    theme="legacy"
                        rowData={rowData}
                        animateRows
                        onGridReady={onGridReady}
                        rowHeight={30}
                        headerHeight={44}
                        paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        pagination
                        defaultColDef={{
                            resizable: true
                        }}
                        columnDefs={tableHeaders.map(header => {
                            if (header.field === "problem") {
                                return {
                                    key: header.field,
                                    ...header,
                                    sortable: false,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    // cellRenderer: {(event) => (<ParametersComponent data={event.data}/>)}
                                    wrapText: true,
                                    autoHeight: true,
                                }
                            } if (header.field === "status") {
                                return {
                                    key: header.field,
                                    ...header,
                                    sortable: false,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    cellRenderer: (event) => {
                                        return (
                                            <span
                                                style={{
                                                    backgroundColor: event.value.toLowerCase() === 'resolved' ? '#f2ffeb' : '#FFFAEB',
                                                    color: event.value.toLowerCase() === 'resolved' ? '#4bf709' : '#F79009',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    border: `1px solid ${event.value.toLowerCase() === 'resolved' ? '#4bfe59' : '#FEC84B'}`,
                                                    borderRadius: '16px',
                                                    padding: '2px 16px'
                                                }}
                                            >
                                                {event.value.charAt(0).toUpperCase() + event.value.slice(1).toLowerCase()}
                                            </span>
                                        );
                                    },
                                    wrapText: true,
                                }
                            }
                            if (['Recovery Time', 'Event Date & Time'].includes(header.field)) {
                                return {
                                    ...header,
                                    sortable: false,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    wrapText: true,
                                    cellRenderer: (event) => {
                                        return (
                                            <span>{!event.value ? event.value : convertToTimezone(event.value, 'date')}</span>
                                        )
                                    }
                                }
                            }
                            return {
                                ...header,
                                sortable: false,
                                flex: 1,
                                filter: "agTextColumnFilter",
                                wrapText: true,
                            }
                        })}
                     />
                </div>
            }
        </>
    )

    // return (
    //     <>
    //         <div className={classes.root} style={{ height: 290, width: '100%', overflow: "auto" }}>
    //             <DataGrid
    //                 rows={incidents}
    //                 columns={columns}
    //                 hideFooter
    //             />
    //         </div>
    //     </>
    // )
}

export default withRouter(IncidentsTab)
